function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".poster-quick-1{fill:current;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "poster-quick-1",
  d: "M22.2,30.2h-8a.77.77,0,1,0,0,1.53h8a.77.77,0,0,0,0-1.53Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "poster-quick-1",
  d: "M21.58,7.88,15,14.35A2.43,2.43,0,0,0,16.7,18.5a2.51,2.51,0,0,0,1.7-.68L25,11.29A9.56,9.56,0,0,0,21.58,7.88Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "poster-quick-1",
  d: "M32.2,16.23a15.49,15.49,0,1,0-6.78,12.82l2.67,2.68H32.2V27.62L29.52,25A15.5,15.5,0,0,0,32.2,16.23Zm-5.82,0A9.69,9.69,0,1,1,16.7,6.54a9.53,9.53,0,0,1,4.88,1.34S24,5.6,24.16,5.5a13.28,13.28,0,0,1,3.26,3.26c-.1.17-2.39,2.53-2.39,2.53A9.7,9.7,0,0,1,26.38,16.23Z"
});

var SvgQuick = function SvgQuick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 33.39 33.4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quick.a8b00bb8.svg";
export { ForwardRef as ReactComponent };